// app/javascript/pages/star_rating.ts
// Interactive star rating component for the results page

const RATING_LABELS: Record<number, string> = {
  1: "Could be better...",
  2: "Not bad",
  3: "Good!",
  4: "Great!",
  5: "Excellent!",
};

export function initStarRating(): void {
  const container = document.querySelector('[data-controller="star-rating"]');
  if (!container) return;

  const stars = container.querySelectorAll<HTMLButtonElement>(
    '[data-star-rating-target="star"]',
  );
  const label = container.querySelector<HTMLSpanElement>(
    '[data-star-rating-target="label"]',
  );

  if (stars.length === 0) return;

  // Handle hover effects
  stars.forEach((star, index) => {
    star.addEventListener("mouseenter", () => {
      highlightStars(stars, index + 1);
      updateLabel(label, index + 1);
    });

    star.addEventListener("mouseleave", () => {
      resetStars(stars);
      resetLabel(label);
    });
  });

  // Handle click - set hidden field and submit the form
  stars.forEach((star) => {
    star.addEventListener("click", (e) => {
      e.preventDefault();
      const form = container.closest("form");
      const hiddenField =
        form?.querySelector<HTMLInputElement>("#rating_value");
      const ratingValue = star.getAttribute("data-rating-value");

      if (form && hiddenField && ratingValue) {
        hiddenField.value = ratingValue;
        // Add a brief animation before submitting
        star.style.transform = "scale(1.3)";
        setTimeout(() => {
          form.submit();
        }, 150);
      }
    });
  });
}

function highlightStars(
  stars: NodeListOf<HTMLButtonElement>,
  count: number,
): void {
  stars.forEach((star, index) => {
    if (index < count) {
      star.classList.remove("text-white/20");
      star.classList.add("text-yellow-400", "scale-110");
    } else {
      star.classList.add("text-white/20");
      star.classList.remove("text-yellow-400", "scale-110");
    }
  });
}

function resetStars(stars: NodeListOf<HTMLButtonElement>): void {
  stars.forEach((star) => {
    star.classList.add("text-white/20");
    star.classList.remove("text-yellow-400", "scale-110");
  });
}

function updateLabel(label: HTMLSpanElement | null, rating: number): void {
  if (label) {
    label.textContent = RATING_LABELS[rating] || "";
    label.classList.remove("opacity-0");
    label.classList.add("opacity-100");
  }
}

function resetLabel(label: HTMLSpanElement | null): void {
  if (label) {
    label.textContent = "How was the challenge?";
    label.classList.remove("opacity-100");
    label.classList.add("opacity-0");
  }
}
